<template>
	<div class="job-card">
		<div v-if="selected" class="job-card-selected tw-flex tw-justify-center tw-items-center">
			<p class="job-name tw-m-0 tw-text-center">{{ job.name }}</p>
		</div>
		<div class="job-card-content tw-flex tw-justify-center tw-items-center">
			<div>
				<check-icon class="check-icon" :color="completed ? 'success' : ''"/>
			</div>
			<p class="job-name tw-m-0 tw-text-center">{{ job.name }}</p>
			<div class="job-options">
				<img
					src='/static/img/evaluation/icons/new-file-1.svg'
					class="tw-mr-4"
					@click="$emit('editionClick', job)"
				/>
				<img
					src='/static/img/evaluation/icons/delete-button.svg'
					class=""
					@click="onDeleteClick"
				/>
			</div>
		</div>
		<confirm-dialog ref="confirmDialog" />
	</div>
</template>

<script>
import CheckIcon from '@/modules/shared/components/icons/check-icon';
import ConfirmDialog from '@/modules/shared/components/ui/ConfirmDialog';

export default {
	name: 'guideline-model-job-item',
	components: { ConfirmDialog, CheckIcon },
	props: ['job', 'selected', 'completed'],
	methods: {
		onDeleteClick() {
			this.$refs.confirmDialog.showConfirm({
				onOk: () => { this.$emit('deleteClick', this.job); },
				title: `¿Seguro que desea eliminar "${this.job.name}" de la lista?`,
			});
		},
	},
};
</script>

<style lang='scss' scoped>
	.job-card {
		border-radius: 10px;
		box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
		border: solid 2px var(--app-color-primary);
		background-color: #ffffff;
		padding-bottom: 90%;
		position: relative;
		.job-card-selected, .job-card-content {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
		}
		.job-card-selected {
			z-index: 1;
			background: var(--app-color-primary);
			.job-name {
				color: #ffffff !important;
				font-size: 16px;
			}
		}
		.job-card-content {
			padding: 20px 10px;
			text-align: center;
			.job-name {
				color: var(--app-color-primary);
				font-size: 14px;
				line-height: 14px;
			}
			.check-icon {
				position: absolute;
				top: 5px;
				right: 5px;
				width: 20px;
			}
			.job-options {
				position: absolute;
				bottom: 5px;
				left: 0;
				right: 0;
				img {
					cursor: pointer;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-list/guideline-model-job-item.vue